// extracted by mini-css-extract-plugin
export default {"hr_line":"DiagsList_hr_line__RymCy","muted":"DiagsList_muted__e18LC","inherit":"DiagsList_inherit__dS18N"};